<template>
  <div>
    <quill-editor
      aria-label="Text"
      v-model="answer"
      @change="handleChange($event)"
      :options="editorOptions"
      class="mt-2"
    />
    <ValidationProvider
      v-slot="{ errors, validate }"
      :rules="validatonRules"
      ref="validationProvider"
    >
      <div
        v-if="showValidationErrors && errors && errors.length"
        class="text-error"
      >
        <span v-for="(error, index) in errors" :key="index">{{ error }}</span>
      </div>
      <div
        class="character-counter"
        v-if="question.characterLimit"
        :class="{ 'text-error': isAboveCharLimit }"
      >
        {{ characterCount }} of {{ question.characterLimit }} characters
      </div>
      <div class="mb-2"></div>
    </ValidationProvider>
  </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { first } from "lodash";
import { DEFAULT_TOOLBAR_OPTIONS } from "@/plugins/v-quill-editor";

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    showValidationErrors: Boolean
  },
  components: {
    ValidationProvider
  },
  mounted() {
    if (this.question.answerData) {
      this.answer = first(this.question.answerData.answers);
      this.$refs.validationProvider.syncValue(this.strippedString);
    }
  },
  data() {
    return {
      answer: null,
      text: null,
      editorOptions: {
        modules: {
          toolbar: {
            container: DEFAULT_TOOLBAR_OPTIONS
          }
        }
      }
    };
  },
  computed: {
    validatonRules() {
      const { characterLimit } = this.question;
      const basicValidation = "required";
      if (this.question.characterLimit) {
        return `${basicValidation}|max:${characterLimit}`;
      }
      return basicValidation;
    },
    strippedString() {
      if (this.answer) {
        return this.answer.replace(/(<([^>]+)>)/gi, "");
      }
      return "";
    },
    characterCount() {
      if (this.text) {
        return this.text.length;
      }

      return this.strippedString.length;
    },
    isAboveCharLimit() {
      return (
        this.question.characterLimit &&
        this.answer &&
        this.characterCount > this.question.characterLimit
      );
    }
  },
  methods: {
    handleChange(value) {
      this.text = value.text.replace("\n", "");
      this.$refs.validationProvider.syncValue(this.text);

      this.$emit("onChange", {
        answers: [value.html],
        question: {
          type: "booking-application-questions",
          id: this.question.id
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.character-counter {
  padding: 12px 10px;
  margin-top: -2px;
}
</style>
